module.exports = __webpack_public_path__ + "img/fuel.bdbe3abb.png";